import { useCallback, useMemo, useState } from "react";
import { toast } from "sonner";
import { api } from "./api";

/**
 * useMultiSelect — reusable checkbox-selection hook for list pages.
 * Only meaningful for admins; guards inside the component decide when to show the UI.
 *
 * Usage:
 *   const { selected, isSelected, toggle, toggleAll, clear, hasAny } = useMultiSelect();
 *   ...
 *   <input type="checkbox" checked={isSelected(id)} onChange={() => toggle(id)} />
 *   <MultiSelectBar count={selected.length} resource="issues" onCleared={() => { clear(); reload(); }} />
 */
export function useMultiSelect() {
  const [selected, setSelected] = useState([]);
  const isSelected = useCallback((id) => selected.includes(id), [selected]);
  const toggle = useCallback((id) => {
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  }, []);
  const toggleAll = useCallback((allIds) => {
    setSelected(prev => (prev.length === allIds.length ? [] : [...allIds]));
  }, []);
  const clear = useCallback(() => setSelected([]), []);
  const hasAny = selected.length > 0;
  return { selected, isSelected, toggle, toggleAll, clear, hasAny };
}

export async function bulkDelete(resource, ids) {
  if (!ids || ids.length === 0) return { deleted: 0 };
  const r = await api.post(`/bulk-delete/${resource}`, { ids });
  return r.data;
}
